import React from 'react'
import { Calendar } from 'lucide-react'
import { designTokens } from '@/utils/design-tokens'

interface CalendarTriggerProps {
  onClick: () => void
  className?: string
  disabled?: boolean
}

const CalendarTrigger: React.FC<CalendarTriggerProps> = ({
  onClick,
  className = '',
  disabled = false
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center justify-center w-8 h-8 rounded-md
        transition-all duration-150 hover:bg-gray-100 focus:outline-none
        focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      style={{
        color: designTokens.colors.gray[5],
        backgroundColor: 'transparent',
        border: `1px solid ${designTokens.colors.gray[2]}`
      }}
      aria-label="날짜 선택 캘린더 열기"
      type="button"
    >
      <Calendar
        className="w-4 h-4"
        strokeWidth={2}
      />
    </button>
  )
}

export default CalendarTrigger